import { render, staticRenderFns } from "./QuizzDialog.vue?vue&type=template&id=3bec9e5e&scoped=true&"
import script from "./QuizzDialog.vue?vue&type=script&lang=js&"
export * from "./QuizzDialog.vue?vue&type=script&lang=js&"
import style0 from "./QuizzDialog.vue?vue&type=style&index=0&id=3bec9e5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bec9e5e",
  null
  
)

export default component.exports